import { useAuth } from "../auth/useAuth";

/**
 * Thin wrapper over useAuth's role facts, named the way decomposition.md section 6.2 names it.
 * Kept separate from useAuth so a feature only needs role-gating logic to import this, not the
 * whole auth surface (login/logout).
 */
export function useCallerPermissions() {
  const { caller, hasRole } = useAuth();
  return { role: caller?.role ?? null, hasRole };
}
